// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentOptions_container__1sX5Y","icon":"PaymentOptions_icon__L95Pf"};